import { Grid } from 'src/design/atoms/Grid';
import { Loader } from 'src/design/atoms/Loader';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useWorkTicket } from 'src/api/queries/workTickets/useWorkTicket';
import { Header } from 'src/design/organisms/Header';
import { useJobs } from 'src/hooks/useJobs';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';
import { WorkTicketForm } from 'src/routes/Jobs/Tickets/WorkTicketForm';

export const EditTicket: React.FC = () => {
  const { selectedJob } = useJobs();
  const { ticketId }: any = useParams();
  const navigate = useNavigate();
  const { data: ticket, isLoading } = useWorkTicket(selectedJob?.id, ticketId);

  if (!selectedJob) return null;
  return (
    <>
      <Header
        title="Create"
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            {
              text: 'Work Tickets',
              href: `/jobs/${selectedJob.id}/tickets`,
            },
            { text: 'Create' },
          ],
        }}
        helpText="Edit this work ticket's details."
      />
      <Grid>
        <Grid.Col>
          {isLoading || !ticket ? (
            <div className="text-center">
              <Loader />
            </div>
          ) : (
            <WorkTicketForm
              jobId={selectedJob.id}
              initialValues={ticket}
              ticketId={ticketId}
              sideCancelButton={
                <SecondaryButton
                  fullWidth
                  className="m-b-15"
                  onClick={() => navigate(`/jobs/${selectedJob.id}/tickets`)}
                >
                  Cancel
                </SecondaryButton>
              }
              cancelButton={
                <SecondaryButton
                  className="m-r-10"
                  onClick={() => navigate(`/jobs/${selectedJob.id}/tickets`)}
                >
                  Cancel
                </SecondaryButton>
              }
            />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};
